/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderCredentialV2FormConfiguration,
    ProviderCredentialV2FormConfigurationFromJSON,
    ProviderCredentialV2FormConfigurationToJSON,
    ProviderCredentialV2FormData,
    ProviderCredentialV2FormDataFromJSON,
    ProviderCredentialV2FormDataToJSON,
    ProviderCredentialV2ValidationData,
    ProviderCredentialV2ValidationDataFromJSON,
    ProviderCredentialV2ValidationDataToJSON,
} from '../models';

export interface ApiProviderCredentialsV2ProviderCredentialV2FormCreatePostRequest {
    providerCredentialV2FormData?: ProviderCredentialV2FormData;
}

export interface ApiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGetRequest {
    providerId?: string;
}

export interface ApiProviderCredentialsV2ProviderCredentialV2FormGetByIdGetRequest {
    id?: string;
}

export interface ApiProviderCredentialsV2ProviderCredentialV2FormUpdatePostRequest {
    providerCredentialV2FormData?: ProviderCredentialV2FormData;
}

export interface ApiProviderCredentialsV2ProviderCredentialV2FormValidatePostRequest {
    providerCredentialV2FormData?: ProviderCredentialV2FormData;
}

/**
 * no description
 */
export class ProviderCredentialV2FormApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormCreatePostRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2Form/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialV2FormDataToJSON(requestParameters.providerCredentialV2FormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormCreatePost(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormCreatePostRequest): Promise<string> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2FormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGetRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGetRequest): Promise<runtime.ApiResponse<ProviderCredentialV2FormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.providerId !== undefined) {
            queryParameters['providerId'] = requestParameters.providerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2Form/FormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialV2FormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGet(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGetRequest): Promise<ProviderCredentialV2FormConfiguration> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2FormFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormGetByIdGetRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormGetByIdGetRequest): Promise<runtime.ApiResponse<ProviderCredentialV2FormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2Form/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialV2FormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormGetByIdGet(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormGetByIdGetRequest): Promise<ProviderCredentialV2FormData> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2FormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormUpdatePostRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2Form/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialV2FormDataToJSON(requestParameters.providerCredentialV2FormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormUpdatePost(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormUpdatePostRequest): Promise<void> {
        await this.apiProviderCredentialsV2ProviderCredentialV2FormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormValidatePostRaw(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormValidatePostRequest): Promise<runtime.ApiResponse<ProviderCredentialV2ValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentialsV2/ProviderCredentialV2Form/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialV2FormDataToJSON(requestParameters.providerCredentialV2FormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialV2ValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsV2ProviderCredentialV2FormValidatePost(requestParameters: ApiProviderCredentialsV2ProviderCredentialV2FormValidatePostRequest): Promise<ProviderCredentialV2ValidationData> {
        const response = await this.apiProviderCredentialsV2ProviderCredentialV2FormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
